import AbstractScene from './AbstractScene.js';

import RoundedButton from '../prefabs/RoundedButton.js';

import {Colors} from '../consts/Colors'
import eventsCenter from '../sydo/prefab/EventCenter.js';

export default class Video extends AbstractScene {
    constructor() {
        super({
            key: "Video"
        })
    }
    init(data) {
        this._init(data);
        eventsCenter.emit('showtitle')
    }

    preload() {
        
        this._preload();

        // this.displayDomDiv()
    }

    create(){
        // Ajout line
        var line = this.add.sprite(0, 965, 'backLine').setOrigin(0)
        
        // Ajout vidéo
        this.launchVideo("video", ()=>{}, false)

        // Ajout bouton continuer
        this.add.rexRoundRectangle(this.width/2, 980, 500, 80, 80/2, Colors.Elmt.White);
        this.button = new RoundedButton(this, this.width/2, 980, 500, 80, "Démarrer le jeu", Colors.Text.Purple, Colors.Elmt.Purple)
        this.button.setClickFunction(()=>{this.finVideo()})
        this.button.setLocked()

        this.time.addEvent({
            delay: 2000,
            callback: ()=> { this.button.setUnlocked()}
        })
    }

    launchVideo(video_name, endFunc, autoPlay){
        this.video = this.add.dom(320, 190).setOrigin(0)
        this.video.createFromCache('videoPlayer')
    }

    finVideo(){
        // Cache
        // this.hideDomDiv()
        eventsCenter.emit('hidetitle')

        // Start scene jeu
        this.nextScene()

    }

    displayDomDiv(){
        var divElmt = document.getElementById("game").children[0]
        divElmt.style.display = "block"
        divElmt.style.pointerEvents = ""
    }

    hideDomDiv(){
        var divElmt = document.getElementById("game").children[0]
        divElmt.style.pointerEvents = "none"
    }

    
}